import { FONTS, COLORS } from '../../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');

  return {
    root: {
      backgroundColor: COLORS.WHITE,
      padding: '40px 0 0 0',
      marginTop: 56,
      [minSm]: {
        marginTop: 64,
        marginLeft: 200,
        width: 'calc(100vw - 200px)',
      },
    },
    innerWrapper: {
      maxWidth: 1200,
      margin: '0 auto',
    },
    headingContainer: {
      display: 'flex',
    },
    heading: {
      display: 'inline-block',
      fontFamily: FONTS.SECONDARY,
      color: COLORS.GREY_DARK,
      fontWeight: 100,
      margin: '0 0 40px 0',
      padding: '0 16px',
      [minSm]: {
        padding: '0 20px 0 30px',
      },
    },
    faqSubheadingContainer: {
      margin: '0 0 40px 0',
      padding: '0 16px',
      [minSm]: {
        padding: '0 20px 0 30px',
      },
    },
    faqSubheading: {
      margin: '0px 0px 40px 0px',
      [minMd]: {
        margin: '0px 0px 40px 40px',
      },
    },
    QACard: {
      padding: '1.5rem 3rem',
      marginBottom: '2rem',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%',
      [minMd]: {
        width: '80%',
        maxWidth: '80%',
      },
    },
    answerText: {
      fontFamily: FONTS.PRIMARY,
    },
    QAImage: {
      display: 'flex',
      justifyContent: 'center',
      minWidth: '100%',
    },
    imageContainImg: {
      display: 'block',
      width: '100%',
      maxHeight: '100vh',
      [minMd]: {
        width: '80%',
      },
    },
  };
};

export default styles;
